<template>
  <div class="wrapper-jobs">
    <AdminDashboard v-if="$hasRole(['admin'])" />
    <EmployerDashboard v-if="$hasRole(['employer'])" />
    <UserDashboard v-if="$hasRole(['candidate'])" />
    <HrDashboard v-if="$hasRole(['hr'])" />
  </div>
</template>

<script>
import AdminDashboard from '@/views/jobs/admin/AdminDashboard';
import EmployerDashboard from '@/views/jobs/employer/EmployerDashboard';
import UserDashboard from '@/views/jobs/user/UserDashboard';
import HrDashboard from '@/views/jobs/hr/HrDashboard';

export default {
  name: 'Dashboard',
  components: {
    UserDashboard,
    EmployerDashboard,
    AdminDashboard,
    HrDashboard
  }
}
</script>
